import React, { Component } from 'react'
import { Input } from '@driftt/tide-core-legacy'
import cx from 'classnames'

import './style.styl'

export const IntegrationToggle = ({ toggle, onChange, disabled, isVisible=true }) => (
  <div className={cx('integration-toggle', {"toggle-not-visible": !isVisible})}>
    <label>
      <Input
          type="checkbox"
          checked={toggle.value}
          label={toggle.label}
          description={toggle.description && <p>{toggle.description}</p>}
          onChange={event => onChange(event, toggle)}
          disabled={disabled}
        />
    </label>
  </div>
)

const IntegrationToggles = ({ toggles, onChange, disabled, onSuccess, noPadding }) => {
  return (
    <div className={cx('', { "integration-toggles drift-form": !noPadding })}>
      {
        toggles.map((toggle, index) => {
          return (
            <div key={index}>
              <IntegrationToggle
                toggle={toggle}
                onChange={onChange}
                disabled={disabled}
                key={`${toggle.type}-${toggle.value}`}
              />
              {toggle.children &&
                <IntegrationAdvancedToggles
                  toggles={toggle.children}
                  onChange={onChange}
                  isEnabled={toggle.value}
                  onSuccess={onSuccess}
                  openAdvancedSettingsOnEnable={!!toggle.openAdvancedSettingsOnEnable}
                />
              }
            </div>
          )
        })
      }
    </div>
  )
}

class IntegrationAdvancedToggles extends Component {
  state = {
    show: false
  }

  componentDidUpdate(prevProps) {
    const { isEnabled } = this.props

    const toggleWasJustDisabled = prevProps.isEnabled && !isEnabled
    if (toggleWasJustDisabled && this.state.show) {
      this.toggle()
    }

    const toggleWasJustEnabled = !prevProps.isEnabled && isEnabled
    if (prevProps.openAdvancedSettingsOnEnable && toggleWasJustEnabled && !this.state.show) {
      this.openAdvancedSettings()
    }
  }

  openAdvancedSettings = () => {
    this.setState({
      show: true
    })
  }

  toggle = () => {
    const { isEnabled } = this.props
    if (!isEnabled) {
      return
    }
    this.setState(prevState => ({
      show: !prevState.show
    }))
  }

  render() {
    const { toggles, onChange, onSuccess, isEnabled } = this.props
    const { advancedComponent: AdvancedComponent } = toggles
    const { show } = this.state

    const autoExpand = !!toggles.autoExpand
    const showAdvancedSettings = isEnabled && (show || autoExpand)
    const toggleText = showAdvancedSettings ? 'Hide' : 'Show'

    const showIntegrationTogglesAdvancedItems = toggles.topLevelAdvancedItems && toggles.topLevelAdvancedItems.length > 0
    const showIntegrationTogglesItems = toggles.items && toggles.items.length > 0

    return (
      <div className="advanced-integration-toggles">
      {!autoExpand &&
        <span
          className={cx('', { 'advanced-integration-disabled-text': !isEnabled })}
          onClick={this.toggle}
          >
          {toggleText} advanced integration sync settings
        </span>
      }
        {showAdvancedSettings &&
          <div className="advanced-integration-toggles-content">
            <div className="advanced-integration-toggle-header">
              {
                showIntegrationTogglesAdvancedItems && 
                <IntegrationToggles disabled={!isEnabled} toggles={toggles.topLevelAdvancedItems} onChange={onChange}/>
              }
              <strong>{toggles.label}</strong>
              <p>{toggles.description}</p>
              {
                showIntegrationTogglesItems &&
                <IntegrationToggles disabled={!isEnabled} toggles={toggles.items} onChange={onChange}/>
              }
              {
                AdvancedComponent &&
                <AdvancedComponent
                  isEnabled={isEnabled}
                  onSuccess={onSuccess}
                />
              }
            </div>              
          </div>
        }
      </div>
    )
  }
}

export default IntegrationToggles



// WEBPACK FOOTER //
// ./src/scripts/components/IntegrationToggles/index.js